import BaseEntity        from "@/core/misc/BaseEntity";
import Title_ru_RU       from "@/core/misc/decorators/Title_ru_RU";
import TYPES             from "@/core/services/Changelogs/types";
import Title_ru_RU_Class from "@/core/misc/decorators/Title_ru_RU_Class";

@Title_ru_RU_Class('Тип транспорта')                // vehicleType → VehicleType
class VehicleType extends BaseEntity {
	static Events = {
		Created: 'vehicleType:created',
		Updated: 'vehicleType:updated',
		Deleted: 'vehicleType:deleted',
	} as const;

	/** наименование */
	@Title_ru_RU('Название', TYPES.STRING)
	public name: string;

	static fromServer(data: any, result = new VehicleType()): VehicleType {
		super.fromServer(data, result);

		return result;
	}

  toString(): string {
    return this.name;
  }
}

export default VehicleType;
